import { Injectable } from '@angular/core';
import { AppConfig } from '../../app/app.config';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { PtLuxonDate } from 'models/projects/date.models';
import { DprAttachmentFile } from 'models/dpr-attachments/dpr-attachments.models';

@Injectable()
export class DprAttachmentFileUploadService {

  config = AppConfig.settings;

  constructor(
    private http: HttpClient,
  ) {
  }

  public getUploadedFiles(dprDate: PtLuxonDate): Observable<DprAttachmentFile[]> {
    const url = `${this.config.apiUrl}api/dpr-attachments/${dprDate.dateTime}/get-files`;
    return this.http.get<DprAttachmentFile[]>(url);
  }

  public uploadFile(f: File, dailyLogDate: PtLuxonDate): Observable<HttpEvent<DprAttachmentFile>> {
    const url = `${this.config.apiUrl}api/dpr-attachments/${dailyLogDate.dateTime}/upload-file`;

    // Build Form Data
    const formData = new FormData();
    formData.append(f.name, f);

    return this.http.post<DprAttachmentFile>(url, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  public deleteFile(guid: string) {
    const url = `${this.config.apiUrl}api/dpr-attachments/${guid}/delete-file`;
    return this.http.get(url);
  }

  public downloadFile(guid: string): Observable<Blob> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    const url = `${this.config.apiUrl}api/dpr-attachments/${guid}/get-file`;
    return this.http.get(url, { headers, responseType: 'blob' });
  }
}


// WEBPACK FOOTER //
// ./src/services/dpr-attachments/dpr-attachments-file-upload.service.ts